/* eslint-disable no-confusing-arrow */
import { updateVendorPayload } from '../../models/payload/vendor';
import { ropoloRequest } from '../axios';

const vendorMe = async () => (await ropoloRequest.identityVendorsMeList()).data;
const vendorMeWithOutNetworkCheck = async () => (await ropoloRequest.identityVendorsMeList()).data;

const vendorBrands = async () => (await ropoloRequest.identityVendorsGetvendorbrandsList()).data;

const vendorMeByDomain = async (hostDomain: string) => (await ropoloRequest.identityVendorsList({ hostDomain })).data;

const getVendorByDomainServerSide = async (hostDomain: string) =>
  (await ropoloRequest.server.identityVendorsList({ hostDomain })).data;

const updateVendor = async (command: updateVendorPayload) =>
  (await ropoloRequest.identityVendorsMeUpdate(command)).data;

const getDefaultDescriptions = async (query?: {
  IsActive?: boolean;
  PageNumber?: number;
  PageSize?: number;
  Search?: string;
  networkStatus?: boolean;
  HostDomain?: string;
}) => (await ropoloRequest.identityDefaultdescriptionList(query)).data;

const getLanding = async (hostDomain: string) =>
  (
    await ropoloRequest.server.identityVendorsLandingList({
      headers: {
        hostDomain,
      },
    })
  ).data;

const getRocketPayDetail = async (id: string) => (await ropoloRequest.server.paymentsLinkDetail(id)).data;

const updateBranchNotif = async (params: { vendorId: string; isSubscribed: boolean }) =>
  (await ropoloRequest.identityVendorsSubscribevendorbrandUpdate(params)).data;

export {
  getDefaultDescriptions,
  getLanding,
  getRocketPayDetail,
  getVendorByDomainServerSide,
  updateVendor,
  vendorBrands,
  vendorMe,
  vendorMeByDomain,
  vendorMeWithOutNetworkCheck,
  updateBranchNotif,
};
